import React , { useState, useEffect } from 'react';
import {useParams} from 'react-router-dom';
import './carteira.css';
import firebase, { storage } from '../Config/firebase';

import { collection, doc, getDoc, getFirestore, setDoc } from 'firebase/firestore';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';

function Carteira(props){

    const [subnome,setSubnome] = useState('');
    const [subsiape,setSubsiape] = useState('');
    const [subcpf,setSubcpf] = useState('');
    const [suburlcart,setSuburlcart] = useState('');
    const [imgURL, setImgURL] = useState('');
    const params = useParams();
    const db = getFirestore();
    var cartdat = Date();

    function CartIni() {
     console.log('Nome do url:', suburlcart);
     if (suburlcart){
     const pathReference = ref(storage, suburlcart);
     getDownloadURL(pathReference).then (url => {
      setImgURL(url);
     })
    }
    }

    function aplicarMascaraCPF(valor) {
    // Remove tudo o que não for dígito
    let digitos = valor.replace(/\D/g, ''); 
    
    // Limita a 11 caracteres
    digitos = digitos.substring(0, 11); 

    // Aplica a formatação de CPF (000.000.000-00)
    return digitos
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}

    useEffect(() =>{
              const fetchData = async () => {
    
              const docRef = doc(db, 'clientes', params.id);
              const docSnap = await getDoc(docRef);
    
              if (docSnap.exists()) {
                 setSubnome(docSnap.data().nome);
                 setSubsiape(docSnap.data().siape);
                 setSubcpf(docSnap.data().cpf);
                 setSuburlcart(docSnap.data().urlcart);
              } else {
                // docSnap.data() will be undefined in this case
                console.log("Não encontrado!");
              }
            }
            fetchData();
         }, [])




    return <section id="carteira">
                <button onClick={CartIni} type="button" className="btn btn-primary btn-foto">Clique aqui</button>
                <div className="flex-row flex-wrap">                    
                       <div className="col-lg-4">
                       <img src="/images/Carteira5.jpg" fluid className="imgcart"/>
                       {imgURL  && <img  src={imgURL} fluid alt="Imagem" className="imgfoto"/>}

                       <h1 className='h1cart'> {subnome} </h1>
                       <h1 className='h1cart2'> CPF </h1>
                       <h1 className='h1cart3'> {aplicarMascaraCPF(subcpf)} </h1>

                       <h1 className='h1cart21'> SIAPE </h1>
                       <h1 className='h1cart31'> {subsiape} </h1>
   
                       <h1 className='h1cart4'> Validade 31/08/2026 </h1>
                       </div>           
                </div>
            </section>
           
  }

  export default Carteira;